(function () {
  const REOPEN_KEY = 'sabika_reopen_cart_drawer';

  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 5500;
      const jsonEl = this.querySelector('[data-upsell-json]');
      const data = JSON.parse(jsonEl.textContent);
      this.giftVariantIds = (data.giftVariantIds || []).map(String);
      this.primaryProductIds = (data.primaryProductIds || []).map(String);
      this.reserveProductId = String(data.reserveProductId);

      this.titleEl = this.querySelector('[data-upsell-title]');
      this.cards = Array.from(this.querySelectorAll('[data-upsell-card]'));

      this.cards.forEach((card) => this.wireCard(card));

      document.addEventListener('sabika:cart-mutated', () => this.refresh());
      this.refresh();
    }

    wireCard(card) {
      let selectedVariantId = null;
      const addBtn = card.querySelector('[data-upsell-add]');
      const sizeButtons = card.querySelectorAll('[data-variant-id]');

      sizeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          sizeButtons.forEach((b) => b.classList.remove('cart-upsell__size--selected'));
          btn.classList.add('cart-upsell__size--selected');
          selectedVariantId = btn.dataset.variantId;
          addBtn.disabled = false;
          addBtn.textContent = 'Añadir';
        });
      });

      addBtn.addEventListener('click', async () => {
        if (!selectedVariantId) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Añadiendo...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] }),
          });

          if (!res.ok) {
            // Shopify devolvió un error real (ej. sin stock) -> lo mostramos
            // y NO recargamos, para que el usuario vea qué ha pasado.
            const errData = await res.json().catch(() => null);
            addBtn.disabled = false;
            addBtn.textContent = errData && errData.description ? 'Sin stock' : 'Error, reintenta';
            return;
          }

          // Éxito confirmado por Shopify (status 200) -> recarga directa,
          // sin depender de ningún hook intermedio. Marca que hay que
          // reabrir el drawer al volver a cargar.
          sessionStorage.setItem(REOPEN_KEY, '1');
          window.location.reload();
        } catch (err) {
          // Fallo de red real (sin conexión, etc.)
          addBtn.disabled = false;
          addBtn.textContent = 'Error, reintenta';
        }
      });
    }

    async refresh() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    }

    render(cart) {
      const cartProductIds = cart.items.map((item) => String(item.product_id));

      const nonGiftSubtotal = cart.items.reduce((sum, item) => {
        if (this.giftVariantIds.includes(String(item.variant_id))) return sum;
        return sum + item.final_line_price;
      }, 0);
      this.titleEl.textContent =
        nonGiftSubtotal >= this.threshold
          ? 'Completa tu pedido con...'
          : 'Añade uno de estos y desbloquea tu llavero gratis';

      const availablePrimaries = this.primaryProductIds.filter(
        (id) => !cartProductIds.includes(id)
      );
      const missingCount = this.primaryProductIds.length - availablePrimaries.length;
      const reserveAlreadyInCart = cartProductIds.includes(this.reserveProductId);

      let toShow = [...availablePrimaries];
      if (missingCount > 0 && !reserveAlreadyInCart) {
        toShow.push(this.reserveProductId);
      }

      if (toShow.length === 0) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      this.cards.forEach((card) => {
        const id = card.dataset.productId;
        card.hidden = !toShow.includes(id);
      });
    }
  }

  customElements.define('cart-upsell', CartUpsell);
})();